<template>
    <tr>
        <td
            class="px-6 py-4 whitespace-nowrap text-right items-end align-right text-sm font-medium"
            align="right"
        >
            <p
                v-if="mailing.status == 'sending'"
                class="text-base text-blue-600 animate-bounce font-medium -mt-1"
                style="margin-left: 2px"
            >
                <svg
                    class="animate-spin h-5 w-5 absolute -mt-1"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                    ></circle>
                    <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                </svg>
            </p>

            <router-link
                v-if="mailing.status == 'send'"
                :to="{
                    name: 'mailings-edit',
                    params: {
                        id: mailing.hash,
                        time: timestamp,
                    },
                }"
                replace
                class="cursor-pointer text-blue-600 hover:text-blue-900"
            >
                <EyeIcon
                    class="h-5 w-5 text-blue-600 hover:text-blue-900"
                    aria-hidden="true"
                />
            </router-link>

            <router-link
                v-if="mailing.status == 'concept'"
                :to="{
                    name: 'mailings-edit',
                    params: {
                        id: mailing.hash,
                        time: timestamp,
                    },
                }"
                replace
                class="cursor-pointer text-blue-600 hover:text-blue-900"
            >
                <PencilAltIcon
                    class="h-5 w-5 text-blue-600 hover:text-blue-900"
                    aria-hidden="true"
                />
            </router-link>
        </td>

        <td class="px-6 py-4 whitespace-yeswrap">
            <div class="text-sm font-medium text-gray-900">
                {{ mailing.subject }}

                <p v-if="mailing.send_timestamp" class="text-xs text-gray-700">
                    {{ t("mailings.send_at", "Verstuurd op") }}:
                    {{ mailing.send_timestamp }}
                </p>
            </div>
        </td>

        <td class="px-6 py-4 whitespace-yeswrap">
            <div class="text-sm font-medium text-gray-900">
                {{ mailing.receivers }}

                <span
                    v-if="mailing.role"
                    class="inline-flex items-center px-2.5 py-0.5 ml-2 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                    >{{ mailing.role }}</span
                >
            </div>
        </td>
    </tr>
</template>

<script>
import {
    PencilAltIcon,
    DotsCircleHorizontalIcon,
    DotsHorizontalIcon,
    EyeIcon,
} from "@heroicons/vue/outline";

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/solid";
import Swal from "sweetalert2";
export default {
    mounted() {
        this.timestamp = new Date().getTime();
        Eventing.listen(
            "formMeeting",
            () => (this.timestamp = new Date().getTime())
        );
    },
    created() {},
    components: {
        PencilAltIcon,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        ChevronDownIcon,
        DotsHorizontalIcon,
        EyeIcon,
    },
    props: ["mailing"],
    data() {
        return {
            timestamp: "ts",
            list: "active",
        };
    },
    methods: {
        getTimeStamp() {
            return new Date().getTime();
        },
        setFullHeightTable() {
            Eventing.fire("tableFullHeight");
        },
        capitalize(s) {
            return s[0].toUpperCase() + s.slice(1);
        },
    },
};
</script>
